import {OktaActivationService} from '@common_libraries/Services/login/oktaActivation.service';
import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ValidationService} from '@common_libraries/Services/validation/validation.service';
import {debounceTime} from 'rxjs/operators';
import {LocalStorageService} from 'ngx-webstorage';
import { FormControlPipe } from '@common_libraries/helpers/pipes/form-control.pipe';



@Component({
    selector: 'common-activation',
    templateUrl: './activation.component.html',
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, FormControlPipe]
})

export class ActivationComponent implements OnInit {

  activationGuid: string;
  haveCode: boolean;
  pageMsg: string;
  activateForm: UntypedFormGroup;
  errorsList: Array<ActivateErrors>;
  formValid: boolean = false;

  constructor(private route: ActivatedRoute,                
                private router: Router,
                private localSt: LocalStorageService,
                private fb: UntypedFormBuilder,
                private oktaService: OktaActivationService) {  

                    this.localSt.clear('companyid');
                    this.localSt.clear('isloggedin');
                    this.localSt.clear('moduleauthdata');
                    this.errorsList = [];
                }

  ngOnInit() {
      this.route.queryParams.subscribe(param => {
        // get the query string code value
        this.validateCode(param.Token);
      });
  }

  public validateCode(activationCode: string) {
    this.activationGuid = activationCode;

    if (activationCode === undefined) {
      this.haveCode = false;
      this.pageMsg = 'Reset code not found.';
    } else {

      this.oktaService.VerifyPersonActivation(activationCode).subscribe((res: any) => {
        if (res.json.data) {
          this.createForm();
          this.haveCode = true;
        } else {
          this.haveCode = false;
          this.pageMsg = "The activation code provided is invalid.";

        const myRouter = this.router;
          setTimeout(function(){
            myRouter.navigate(['login']); 
          }, 2000);
        }
      }, (error: any) => {
          this.haveCode = false;
          this.pageMsg = "The activation code provided is invalid."
      });
    }
  }

  public createForm() {
    // // create form
    this.activateForm = this.fb.group({
      pwd: ['', [Validators.required, ValidationService.passwordValidator]],
      confirmPwd: ['', [Validators.required]],
    });

    this.activateForm.get('pwd')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(data => {
        this.activateForm.get('pwd').markAsDirty();
        this.validateForm('pwd');
      });

    this.activateForm.get('confirmPwd')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(data => {
        this.activateForm.get('confirmPwd').markAsDirty();
        this.validateForm('confirmPwd');
      });

  }

  public validateForm(control: string) {
    const pwd = this.activateForm.get('pwd');
    const confirmPwd = this.activateForm.get('confirmPwd');
    let isValid = true;
    if ( control === 'pwd' && pwd.value === '') {
      isValid = false;
      if (this.errorsList.filter( x => x.Name === 'pwd').length === 0) {
        this.errorsList.push(new ActivateErrors('pwd', 'Password is required'))
      }
    }else {
      this.errorsList = this.errorsList.filter( x => x.Name !== 'pwd');
    }

    if ( control === 'confirmPwd' && confirmPwd.value === '' ) {
      isValid = false;
      if (this.errorsList.filter( x => x.Name === 'confirmPwd').length === 0) {
        this.errorsList.push(new ActivateErrors('confirmPwd', 'Confirm Password is required'))
      }
    }else {
      this.errorsList = this.errorsList.filter( x => x.Name !== 'confirmPwd');
    }

    if (pwd.value !== '' && confirmPwd.value !== '' && pwd.value !== confirmPwd.value) {
      isValid = false;
      if (this.errorsList.filter( x => x.Name === 'confirm').length === 0) {
        this.errorsList.push(new ActivateErrors('confirm', 'Password and Confirm Password must match.'))
      }
    }    else {
      this.errorsList = this.errorsList.filter( x => x.Name !== 'confirm');
    }

    // check the pwd form control item
    const pwdErrors = this.activateForm.get('pwd').errors;
    if (pwdErrors !== null && pwdErrors.invalidPassword !== undefined) {
      const msg = ValidationService.getValidatorErrorMessage('invalidPassword');
      const find = this.errorsList.filter( x => x.Name === 'invalidPassword');
      if (find.length === 0) {
        this.errorsList.push(new ActivateErrors('invalidPassword', msg));
      }
      isValid = false;
    } else {
      this.errorsList = this.errorsList.filter( x => x.Name !== 'invalidPassword');
    }

    if (!this.activateForm.valid || !isValid) {
      isValid = false;
    }else {
      this.errorsList = [];
    }

    this.formValid = isValid;
  }



  public submitActivate() {
    const pwd = this.activateForm.get('pwd').value;

    this.oktaService.PersonActivate(this.activationGuid, pwd).subscribe((res: any) => {
      const myRouter = this.router;
      if (res.json.data) {
        this.pageMsg = "Account activated.";
        setTimeout(function(){
          myRouter.navigate(['login']);
        }, 2000);
      }else {
        this.pageMsg = "Error activating user.  Please contact support";

        // setTimeout(function () {
        // myRouter.navigate(['login']);
        // }, 2000);
      }
    });


  }

}export class ActivateErrors {

    Name: string;
    Msg: string;
  
    constructor(_name: string, _msg: string) {
      this.Name = _name;
      this.Msg = _msg;
    }
  }
  